export default "__VITE_ASSET__Bi40rz5P__"